import { AlarmUpdatesDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useSharedAlarmUpdates(
  sharedToken: string,
  searchParams: string,
  refetchInterval: number
) {
  const url = `/shared/v2/alarm/updates?sharedToken=${sharedToken}&${searchParams}`;
  const request = new Request(url);

  return useAuthenticatedRequest<AlarmUpdatesDTO>(request, {
    queryKey: ['alarm_updates', 'shared', sharedToken, { searchParams }],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    refetchInterval,
    noAuth: true,
  });
}

export default useSharedAlarmUpdates;
